import { render, staticRenderFns } from "./collapsibleCard.vue?vue&type=template&id=48f58ebc&scoped=true&"
import script from "./collapsibleCard.vue?vue&type=script&lang=js&"
export * from "./collapsibleCard.vue?vue&type=script&lang=js&"
import style0 from "./collapsibleCard.vue?vue&type=style&index=0&id=48f58ebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f58ebc",
  null
  
)

export default component.exports